import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
const ButtonGroup = function ButtonGroup(props) {
    const { prefixCls: customizePrefixCls, size, className, ...others } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    // large => lg
    // small => sm
    let sizeCls = '';
    switch (size) {
        case Size.large:
            sizeCls = 'lg';
            break;
        case Size.small:
            sizeCls = 'sm';
            break;
        default:
    }
    const classes = classNames(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
    }, className);
    return React.createElement("div", Object.assign({}, others, { className: classes }));
};
ButtonGroup.displayName = 'ButtonGroup';
export default memo(ButtonGroup);
